import React from "react";

import Snackbar from "@material-ui/core/Snackbar";
import MuiAlert from "@material-ui/lab/Alert";

export const SnackbarAlert = React.createContext();

export const SnackbarAlertProvider = ({ children }) => {
  const [snackbarState, setSnackbarState] = React.useState({
    status: "info",
    message: "",
    state: false,
  });
  const handleClose = () => {
    const prevState = snackbarState;
    setSnackbarState({
      status: prevState.status,
      message: prevState.message,
      state: false,
    });
  };

  const state = {
    setSnackbarState: setSnackbarState,
  };
  return (
    <SnackbarAlert.Provider value={state}>
      <Snackbar
        open={snackbarState.state}
        autoHideDuration={3000}
        onClose={handleClose}
        anchorOrigin={{ vertical: "top", horizontal: "center" }}
      >
        <MuiAlert
          elevation={6}
          variant="filled"
          onClose={handleClose}
          severity={snackbarState.status}
        >
          {snackbarState.message}
        </MuiAlert>
      </Snackbar>
      {children}
    </SnackbarAlert.Provider>
  );
};
